"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    sendAnalyticsEvent: ()=>sendAnalyticsEvent,
    useSendEvent: ()=>useSendEvent
});
const _reactQuery = require("react-query");
const _api = require("../api");
const removeNullValues = (obj)=>{
    return Object.fromEntries(Object.entries(obj).filter(([_, value])=>value !== null));
};
const sendAnalyticsEvent = async (event)=>{
    const cleanEvent = removeNullValues(event);
    const params = new URLSearchParams();
    Object.entries(cleanEvent).forEach(([key, value])=>{
        params.append(key, String(value));
    });
    return _api.api.get(`analytics/v1/track?${params}`);
};
const useSendEvent = ()=>{
    return (0, _reactQuery.useMutation)(sendAnalyticsEvent);
};
